import packageJson from '../../package.json';

export const OCL_CLIENT = `oclcommunitysite/${packageJson.version}`;

// External OCL platform destinations (per the Webflow design's nav/footer).
// App links (TermBrowser v2/v3, Mapper, API) are environment-sensitive —
// see common/appLinks.js.
export const CHAT_URL = 'https://chat.openconceptlab.org/';

// The globally pinned OCL Chat topic that carries every call's Zoom room and
// running notes. The site deliberately links here rather than publishing raw
// Zoom registration links, which invite bot joins (ocl_online#147).
export const CHAT_CALLS_URL = `${CHAT_URL}t/ocl-community-calls-zoom-links-and-running-notes/154`;
export const DOCS_URL = 'https://docs.openconceptlab.org/';
export const GITHUB_URL = 'https://github.com/OpenConceptLab';
export const CONTACT_EMAIL = 'info@openconceptlab.org';
export const BILLING_EMAIL = 'billing@openconceptlab.org';

// Per-tool source repositories. The org URL above is the right destination
// for "OCL on GitHub"; a tool page's "view source" has to land on that
// tool's own repo.
export const REPO_URLS = {
  termbrowser: `${GITHUB_URL}/oclweb3`,
  'terminology-service': `${GITHUB_URL}/oclapi2`,
  mapper: `${GITHUB_URL}/oclmap`,
};

// Every code repo has its issue tracker disabled — OpenConceptLab/ocl_issues
// is the single tracker for all of them.
export const ISSUES_URL = `${GITHUB_URL}/ocl_issues/issues`;
export const NEW_ISSUE_URL = `${ISSUES_URL}/new`;

// TermBrowser v3, where OCL Online profiles live. A plain constant rather
// than appLink('termBrowser', …): toV3URL reads window.location and
// localStorage, and blog bylines are prerendered (scripts/prerender.js).
export const TERMBROWSER_URL = 'https://app.v3.openconceptlab.org';
export const oclProfileURL = (username) => `${TERMBROWSER_URL}/users/${encodeURIComponent(username)}/`;

export const CIEL_ORG_URL = `${TERMBROWSER_URL}/orgs/CIEL/`;

// The production Mapper. A plain constant for the same reason as
// TERMBROWSER_URL: prerendered buttons link it until the page mounts
// (common/useAppURLs.js).
export const MAPPER_URL = 'https://map.openconceptlab.org';

// The Brevo form "OCL early access request" that /early-access posts to
// (ocl_online#170). Public by design: the page submits to it directly, and
// Brevo checks the reCAPTCHA token with the secret it holds. Contract in
// docs/superpowers/specs/2026-09-24-early-access-form-design.md.
export const EARLY_ACCESS_FORM_URL = 'https://3f6c85cb.sibforms.com/serve/MUIFADAULRiw5cwPD758Nekd-PPsJIgWmcUKjOs8zc1Bjq5DZfbtbYfZUctquvaLaA9qGiFvTwN4tarZT2XL5dnbmjSHv4ACz9QqKuDyEXokpfh9LHlEJa2BGSRxb9rGcjFrWAtqEc-UrYsP8leoXsqhdiP_kWdCxiHA8Gbbu_wVxvk0UsIQMjSQlXOMcCZUPBei_nUUkDCUeUbS2w==';

// The public half of the reCAPTCHA v2 key pair Brevo's forms use, registered
// for openconceptlab.org and sibforms.com (ocl_online#155).
export const RECAPTCHA_SITE_KEY = '6LcHQcotAAAAAOMn85bOidKWXTMZ2_O0nBKfOqtJ';
